import React, { useEffect } from 'react';
import { Layout } from './components/Layout';
import { Dashboard } from './components/Dashboard';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Committees } from './components/committees/Committees';
import { CommitteeDetail } from './components/committees/CommitteeDetail';
import { SubCommitteeDetail } from './components/committees/SubCommitteeDetail';
import { AddCommittee } from './components/committees/AddCommittee';
import { EditCommittee } from './components/committees/EditCommittee';
import { FormationDecisionsArchive } from './components/committees/FormationDecisionsArchive';
import { ArchivedCommittees } from './components/committees/ArchivedCommittees';
import { Tasks } from './components/tasks/Tasks';
import { TaskDetail } from './components/tasks/TaskDetail';
import { AddTask } from './components/tasks/AddTask';
import { EditTask } from './components/tasks/EditTask';
import { Meetings } from './components/meetings/Meetings';
import { AddMeeting } from './components/meetings/AddMeeting';
import { MeetingDetail } from './components/meetings/MeetingDetail';
import { Reports } from './components/reports/Reports';
import { ReportGenerator } from './components/reports/ReportGenerator';
import { Documents } from './components/documents/Documents';
import { AddDocument } from './components/documents/AddDocument';
import { Communication } from './components/communication/Communication';
import { Settings } from './components/settings/Settings';
import { Login } from './components/auth/Login';
import { AuthProvider } from './components/auth/AuthContext';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
export function App() {
  useEffect(() => {
    document.title = 'sbaapps';
    document.documentElement.dir = 'rtl';
    document.documentElement.lang = 'ar';
  }, []);
  return <Router data-id="element-0">
      <AuthProvider data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/login" element={<Login data-id="element-4" />} data-id="element-3" />
          <Route path="/" element={<ProtectedRoute data-id="element-6">
                <Layout data-id="element-7">
                  <Dashboard data-id="element-8" />
                </Layout>
              </ProtectedRoute>} data-id="element-5" />
          <Route path="/committees" element={<ProtectedRoute data-id="element-10">
                <Layout data-id="element-11">
                  <Committees data-id="element-12" />
                </Layout>
              </ProtectedRoute>} data-id="element-9" />
          <Route path="/committees/add" element={<ProtectedRoute data-id="element-14">
                <Layout data-id="element-15">
                  <AddCommittee data-id="element-16" />
                </Layout>
              </ProtectedRoute>} data-id="element-13" />
          <Route path="/committees/:id" element={<ProtectedRoute data-id="element-18">
                <Layout data-id="element-19">
                  <CommitteeDetail data-id="element-20" />
                </Layout>
              </ProtectedRoute>} data-id="element-17" />
          <Route path="/committees/:id/edit" element={<ProtectedRoute data-id="element-22">
                <Layout data-id="element-23">
                  <EditCommittee data-id="element-24" />
                </Layout>
              </ProtectedRoute>} data-id="element-21" />
          <Route path="/committees/formation-decisions-archive" element={<ProtectedRoute data-id="element-26">
                <Layout data-id="element-27">
                  <FormationDecisionsArchive data-id="element-28" />
                </Layout>
              </ProtectedRoute>} data-id="element-25" />
          <Route path="/committees/archived" element={<ProtectedRoute data-id="element-30">
                <Layout data-id="element-31">
                  <ArchivedCommittees data-id="element-32" />
                </Layout>
              </ProtectedRoute>} data-id="element-29" />
          <Route path="/subcommittees/:id" element={<ProtectedRoute data-id="element-34">
                <Layout data-id="element-35">
                  <SubCommitteeDetail data-id="element-36" />
                </Layout>
              </ProtectedRoute>} data-id="element-33" />
          <Route path="/tasks" element={<ProtectedRoute data-id="element-38">
                <Layout data-id="element-39">
                  <Tasks data-id="element-40" />
                </Layout>
              </ProtectedRoute>} data-id="element-37" />
          <Route path="/tasks/add" element={<ProtectedRoute data-id="element-42">
                <Layout data-id="element-43">
                  <AddTask data-id="element-44" />
                </Layout>
              </ProtectedRoute>} data-id="element-41" />
          <Route path="/tasks/:id" element={<ProtectedRoute data-id="element-46">
                <Layout data-id="element-47">
                  <TaskDetail data-id="element-48" />
                </Layout>
              </ProtectedRoute>} data-id="element-45" />
          <Route path="/tasks/:id/edit" element={<ProtectedRoute data-id="element-50">
                <Layout data-id="element-51">
                  <EditTask data-id="element-52" />
                </Layout>
              </ProtectedRoute>} data-id="element-49" />
          <Route path="/meetings" element={<ProtectedRoute data-id="element-54">
                <Layout data-id="element-55">
                  <Meetings data-id="element-56" />
                </Layout>
              </ProtectedRoute>} data-id="element-53" />
          <Route path="/meetings/add" element={<ProtectedRoute data-id="element-58">
                <Layout data-id="element-59">
                  <AddMeeting data-id="element-60" />
                </Layout>
              </ProtectedRoute>} data-id="element-57" />
          <Route path="/meetings/:id" element={<ProtectedRoute data-id="element-62">
                <Layout data-id="element-63">
                  <MeetingDetail data-id="element-64" />
                </Layout>
              </ProtectedRoute>} data-id="element-61" />
          <Route path="/reports" element={<ProtectedRoute data-id="element-66">
                <Layout data-id="element-67">
                  <Reports data-id="element-68" />
                </Layout>
              </ProtectedRoute>} data-id="element-65" />
          <Route path="/reports/generate" element={<ProtectedRoute data-id="element-70">
                <Layout data-id="element-71">
                  <ReportGenerator data-id="element-72" />
                </Layout>
              </ProtectedRoute>} data-id="element-69" />
          <Route path="/documents" element={<ProtectedRoute data-id="element-74">
                <Layout data-id="element-75">
                  <Documents data-id="element-76" />
                </Layout>
              </ProtectedRoute>} data-id="element-73" />
          <Route path="/documents/add" element={<ProtectedRoute data-id="element-78">
                <Layout data-id="element-79">
                  <AddDocument data-id="element-80" />
                </Layout>
              </ProtectedRoute>} data-id="element-77" />
          <Route path="/communication" element={<ProtectedRoute data-id="element-82">
                <Layout data-id="element-83">
                  <Communication data-id="element-84" />
                </Layout>
              </ProtectedRoute>} data-id="element-81" />
          <Route path="/settings" element={<ProtectedRoute data-id="element-86">
                <Layout data-id="element-87">
                  <Settings data-id="element-88" />
                </Layout>
              </ProtectedRoute>} data-id="element-85" />
          <Route path="*" element={<Navigate to="/login" replace data-id="element-90" />} data-id="element-89" />
        </Routes>
      </AuthProvider>
    </Router>;
}